module.exports = __webpack_public_path__ + "img/1e59289.jpg";